import { Link } from "@mui/material";
import Modal from "../Modal";

const GoogleReview = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      handleClose={onClose}
      style={{
        width: "380px",
      }}
    >
      <div className="flex flex-col gap-4">
        <div className="text-lg leading-tight mb-4">
          <div className="text-lg font-bold leading-tight mb-4">
            Merci de nous avoir partagé votre appréciation
          </div>
          <div className="text-sm text-gray-500 mb-4">
            Aidez-nous à rayonner encore plus en partageant votre expérience sur
            google maps. Ça aide énormément!
          </div>
          <div className="text-sm text-gray-500">
            <Link
              href="https://maps.app.goo.gl/4F7oiacFR5sSGuwaA"
              target="_blank"
              onClick={onClose}
              className="text-blue-500 !text-lg !font-bold"
            >
              Laisser votre avis sur Google maps
            </Link>
          </div>
          <div className="text-sm text-gray-500 mt-4">
            <span
              className="text-gray-400 hover:text-gray-500 text-center mx-auto flex justify-center cursor-pointer"
              onClick={() => {
                // close the modal and redirect to the home page
                onClose();
                window.location.href = "/";
              }}
            >
              Non merci
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default GoogleReview;
